import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import AppName from './AppName';
import PageTitle from './PageTitle';

import ThemeColors from './ThemeColors';

const styles = {
  root: {
    position: "relative",
    color: "#000",
    padding: "16px",
    background: ThemeColors.appName,
    display: "flex",
    alignItems: "center",
    // width: "calc(25% + 55px)",
    width: "calc( 33.333% + 55px)",
    '@media screen and (max-width: 1280px)': {
      width: "100%",
      justifyContent: "center",
    },
  }
}

const AppBrand = ({ classes }) => (
  <div className={classes.root}>
    <img src="/images/seris-logo-dark.png" alt="logo" style={{ height: 32, marginRight: 10 }} />
    <PageTitle title={<AppName />} /> 
  </div>
  
);

export default withStyles(styles)(AppBrand);